/* =========================================================================
   MapleWeld — dock the Shopify Inbox chat button above the mobile action bar.

   THE PROBLEM
   The action bar (Shop / Find a part / Call / Directions) is fixed to the
   bottom of the viewport on phones. Shopify Inbox is a separate app and knows
   nothing about it, so its chat bubble is anchored to the same corner and sat
   directly on top of the Shop button — the single most valuable tap on the
   page, covered by a widget.

   WHY IT IS DONE FROM JAVASCRIPT AND NOT A STYLESHEET
   Inbox renders as <shopify-chat>, a custom element whose button lives inside
   a shadow root. Ordinary theme CSS cannot reach inside a shadow root, so the
   two halves of the fix have to be applied in two different places:

     LIFT  — the host element itself IS ordinary light DOM. It is fixed with
             inset:0, and the button is positioned against the host's bottom
             edge. Raising that edge carries the button, and the expanded chat
             panel, up with it. One page-level rule, no shadow access, nothing
             that breaks if Inbox reorganises its internals.

     SIZE  — only reachable inside the shadow root, which Inbox leaves OPEN, so
             a stylesheet can be appended to it. A transform on the button
             wrapper is used rather than re-specifying height, padding and font
             size, because a transform depends on one class name instead of
             four properties Inbox is free to restyle. If that class ever
             disappears the button simply keeps its stock size — the lift, the
             part that actually matters, is unaffected.

   The bar's height is MEASURED rather than hard-coded, so editing the labels,
   adding a fifth slot or changing its padding re-docks the button correctly
   with no edit here.

   Loaded by sections/mw-home-meta.liquid (close instance) only where the bar
   is rendered, and it no-ops if the bar is absent or Inbox is not installed.
   ========================================================================= */
(function () {
  'use strict';

  var cfg   = document.currentScript;
  var GAP   = Math.max(0, parseInt(cfg && cfg.getAttribute('data-gap'), 10) || 12);
  var SCALE = Math.min(100, Math.max(60, parseInt(cfg && cfg.getAttribute('data-scale'), 10) || 82)) / 100;
  var MOBILE_MAX = 1023;          // the width below which the action bar is on screen
  var GIVE_UP_MS = 20000;         // Inbox loads late and sometimes not at all

  var styleEl = null;
  var shadowDone = false;

  function bar() {
    return document.querySelector('.actionbar');
  }

  /* The bar is display:none above the breakpoint, so a zero height is the
     honest signal that there is nothing to dock above. */
  function barHeight() {
    var el = bar();
    if (!el || window.innerWidth > MOBILE_MAX) return 0;
    var h = Math.round(el.getBoundingClientRect().height);
    return h > 0 ? h : 0;
  }

  function applyLift() {
    var h = barHeight();
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = 'mwh-chat-dock';
      document.head.appendChild(styleEl);
    }
    if (!h) { styleEl.textContent = ''; return; }
    /* !important because the host carries inline positioning from the app. */
    styleEl.textContent =
      'shopify-chat{bottom:' + (h + GAP) + 'px !important;}';
  }

  function applyShadowScale(host) {
    if (shadowDone || SCALE >= 1) return;
    var sr = host.shadowRoot;
    if (!sr) return false;
    if (!sr.querySelector('.activator-nudge')) return false;
    var s = document.createElement('style');
    s.setAttribute('data-mwh', 'chat-dock');
    /* Scaled from its own bottom-left so the anchor point does not drift as
       the button shrinks; the lift above is measured against that same edge. */
    s.textContent =
      '@media (max-width:' + MOBILE_MAX + 'px){' +
      '.activator-nudge{transform:scale(' + SCALE + ');transform-origin:left bottom;}' +
      '}';
    sr.appendChild(s);
    shadowDone = true;
    return true;
  }

  function start() {
    if (!bar()) return;             // not the homepage, or the bar is switched off

    applyLift();
    window.addEventListener('resize', applyLift, { passive: true });
    window.addEventListener('orientationchange', applyLift);

    /* Inbox injects itself well after DOMContentLoaded and builds its shadow
       tree a beat later again, so poll briefly rather than assume either. */
    var t0 = Date.now();
    var timer = setInterval(function () {
      var host = document.querySelector('shopify-chat');
      if (host && applyShadowScale(host)) { clearInterval(timer); return; }
      if (Date.now() - t0 > GIVE_UP_MS) clearInterval(timer);
    }, 400);
  }

  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  } catch (e) {}
}());
